export default {"src":"/_next/static/media/percentage.80a3a40c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};